import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=ed3618f4&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=ed3618f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3618f4",
  null
  
)

export default component.exports